// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Home_loadingContainer__Mgyk5"};